var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.domTogglerArr.length)?_c('a-button',{staticClass:"antd-Button antd-Button--primary antd-Button--size-default",attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.handleMore.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.text))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }